import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { RuleEngineAuthService } from '../services/rule-engine-auth.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class RuleEngineAuthInterceptor implements HttpInterceptor {
  constructor(private authService: RuleEngineAuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Verifica se la richiesta è verso RuleEngine API
    const isRuleEngineRequest = req.url.includes(environment.ruleEngine.apiUrl);

    if (!isRuleEngineRequest) {
      // Non è una richiesta RuleEngine, lascia passare
      return next.handle(req);
    }

    // È una richiesta RuleEngine, aggiungi token Keycloak
    return this.authService.getToken().pipe(
      switchMap((token) => {
        // Clona la richiesta aggiungendo l'Authorization header
        const authReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
        
        return next.handle(authReq).pipe(
          catchError((error: HttpErrorResponse) => {
            // Se otteniamo 401, invalida il token e riprova una volta
            if (error.status === 401) {
              console.warn('⚠️ RuleEngine token rejected (401), invalidating and retrying...');
              this.authService.invalidateToken();
              
              // Riprova con un nuovo token
              return this.authService.getToken().pipe(
                switchMap((newToken) => {
                  const retryReq = req.clone({
                    setHeaders: {
                      Authorization: `Bearer ${newToken}`
                    }
                  });
                  return next.handle(retryReq);
                })
              );
            }
            
            return throwError(() => error);
          })
        );
      }),
      catchError((error) => {
        console.error('❌ RuleEngineAuthInterceptor error:', error);
        return throwError(() => error);
      })
    );
  }
}
